<div class="layout-topbar">
  <div class="layout-topbar-start">
    <button #menubutton type="button" class="p-link layout-menu-button layout-topbar-button" *ngIf="!isOwnPageOnly"
      (click)="layoutService.onMenuToggle()" [attr.aria-label]="'layout.header.toggleMenu' | translate"
      aria-keyshortcuts="Control+B Meta+B"
      [pTooltip]="('layout.header.toggleMenu' | translate) + ' (' + sidebarShortcutLabel + ')'" tooltipPosition="bottom" [showDelay]="400">
      <svg class="layout-menu-button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="M9 3v18" />
      </svg>
    </button>
    <!-- The sidebar carries the logo; this one shows on mobile and when there is no sidebar. -->
    <a class="layout-topbar-logo" routerLink="">
      <img src="assets/images/Logo Kafa'at.png" [alt]="'layout.logoAlt' | translate" />
    </a>
    <span *ngIf="!isOwnPageOnly && breadcrumb().length" class="layout-topbar-separator" aria-hidden="true"></span>
    <nav *ngIf="breadcrumb().length" class="layout-breadcrumb" [attr.aria-label]="'layout.header.breadcrumb' | translate">
      <ol>
        <li *ngFor="let crumb of breadcrumb(); let last = last" [class.layout-breadcrumb-current]="last">
          <span *ngIf="last; else ancestor" aria-current="page">{{ crumbText(crumb.label | translate) }}</span>
          <ng-template #ancestor>
            <a *ngIf="crumbLink(crumb) as link; else plain" [routerLink]="link">{{ crumbText(crumb.label | translate) }}</a>
            <ng-template #plain><span>{{ crumbText(crumb.label | translate) }}</span></ng-template>
            <i class="pi pi-angle-right layout-breadcrumb-separator" aria-hidden="true"></i>
          </ng-template>
        </li>
      </ol>
    </nav>
  </div>

  <!-- Command palette trigger (Ctrl/⌘ K), centred in the header -->
  <div class="layout-topbar-center">
    <button type="button" class="layout-command-trigger" (click)="commandPalette.open()"
      [attr.aria-label]="'commandPalette.trigger' | translate" aria-haspopup="dialog" aria-keyshortcuts="Control+K Meta+K">
      <i class="pi pi-search" aria-hidden="true"></i>
      <span class="layout-command-trigger-text">{{ 'commandPalette.trigger' | translate }}</span>
      <kbd class="layout-command-trigger-kbd" aria-hidden="true">{{ shortcutLabel }}</kbd>
    </button>
  </div>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }">
    <ng-container *ngIf="!isRestrictedMode">
    <ng-container *emPermission="[Permission.JUNIOR_PROMOTION_NOTIFICATION, Permission.TRIAL_PERIOD_ENDING_NOTIFICATION, Permission.CONTRACT_ENDING_NOTIFICATION]">
    <div class="relative">
      <button
        type="button"
        class="p-link layout-topbar-button"
        [attr.aria-label]="'layout.header.notification' | translate"
        [pTooltip]="'layout.header.notification' | translate" tooltipPosition="bottom" [showDelay]="400"
        (click)="openNotificationMenu($event, notificationMenuPanel)">
        <i
          *ngIf="newNotification > 0"
          class="pi pi-bell"
          pBadge
          [value]="newNotification.toString()"
          severity="danger"></i>
        <i *ngIf="newNotification === 0" class="pi pi-bell"></i>
        <span class="title-topbar-button">{{ 'layout.header.notification' | translate }}</span>
      </button>

      <p-overlayPanel #notificationMenuPanel>
        <div
          *ngIf="notificationEmpty; else notificationList"
          class="notification-empty-container"
          style="
            width: 330px;
            max-height: 350px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding: 20px;
            background-color: #f9f9f9;
          ">
          <p class="text-muted" style="font-size: 14px; margin: 0">{{ 'layout.header.noNotifications' | translate }}</p>
        </div>

        <ng-template #notificationList>
          <div class="notification-header">
            <span class="notification-title">{{ 'layout.header.notification' | translate }}</span>
            <button (click)="markAllNotificationsAsRead()" class="mark-all-button">{{ 'layout.header.markAllNotificationsAsRead' | translate }}</button>
          </div>

          <p-menu [model]="notificationMenu" [style]="{ width: '330px', maxHeight: '350px', overflowY: 'auto',border: 'none' }">
            <ng-template pTemplate="item" let-item let-i="index">
              <a
                (click)="popNotification(item)"
                class="p-menuitem-link flex justify-content-between align-items-center p-3"
                [ngClass]="{ unread: !item.isReadable }"
                style="margin: 0 10px; border-bottom: 1px solid rgb(187, 186, 186)">
                <div class="d-flex flex-row">
                  <div class="font-bold mb-2" style="color: rgb(26, 173, 43)">
                    {{ item.notificationType?.type }}
                  </div>
                  <div class="p-text-secondary mb-2" style="font-size: 11px">
                    {{ item.dateTime | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                  <div>{{ item.description }}</div>
                  <span
                    *ngIf="!item.isReadable"
                    class="unread-indicator"
                    style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%)">
                  </span>
                </div>
              </a>
            </ng-template>
          </p-menu>

          <div class="view-all-container">
            <button (click)="loadAllNotifications()" class="p-button p-button-text p-button-sm">{{ 'layout.header.viewAllNotifications' | translate }}</button>
          </div>
        </ng-template>
      </p-overlayPanel>
    </div>
    </ng-container>
    </ng-container>
    <div class="relative">
      <button type="button" class="p-link layout-topbar-button" (click)="languageMenuPanel.toggle($event)"
        [attr.aria-label]="'layout.header.language' | translate"
        [pTooltip]="'layout.header.language' | translate" tooltipPosition="bottom" [showDelay]="400">
        <i class="pi pi-language"></i>
        <span class="title-topbar-button">{{ 'layout.header.language' | translate }}</span>
      </button>

      <p-overlayPanel #languageMenuPanel>
        <p-menu [model]="languageItems" class="w-3rem" [style]="{ border: 'none', padding: '0px' }">
          >
          <ng-template pTemplate="item" let-item>
            <a
              class="p-menuitem-link flex justify-content-between align-items-center p-3"
              [style]="{ height:'2.5rem', padding: '0px' }"
              (click)="changeLanguage(item.code)">
              <span class="p-menuitem-text">{{ item.label | translate }}</span>
            </a>
          </ng-template>
        </p-menu>
      </p-overlayPanel>
    </div>

    @if (isDarkMode()) {
      <button type="button" class="p-link layout-topbar-button" (click)="changeTheme(false)"
        [attr.aria-label]="'layout.header.lightMode' | translate"
        [pTooltip]="'layout.header.lightMode' | translate" tooltipPosition="bottom" [showDelay]="400">
        <i class="pi pi-sun"></i>
        <span class="title-topbar-button">{{ 'layout.header.lightMode' | translate }}</span>
      </button>
    } @else {
      <button type="button" class="p-link layout-topbar-button" (click)="changeTheme(true)"
        [attr.aria-label]="'layout.header.darkMode' | translate"
        [pTooltip]="'layout.header.darkMode' | translate" tooltipPosition="bottom" [showDelay]="400">
        <i class="pi pi-moon"></i>
        <span class="title-topbar-button">{{ 'layout.header.darkMode' | translate }}</span>
      </button>
    }
    <ng-container *ngIf="!isRestrictedMode">
      <button
        *emPermission="configurationPermissions"
        type="button"
        (click)="openConfigurations()"
        class="p-link layout-topbar-button"
        [attr.aria-label]="'layout.header.configurations' | translate"
        [pTooltip]="'layout.header.configurations' | translate" tooltipPosition="bottom" [showDelay]="400">
        <i class="pi pi-cog"></i>
        <span class="title-topbar-button">{{ 'layout.header.configurations' | translate }}</span>
      </button>
    </ng-container>

    <span class="layout-topbar-divider" aria-hidden="true"></span>

    <div class="relative">
      <button type="button" class="p-link layout-topbar-button layout-topbar-profile" (click)="toggleUserProfilePanel($event)"
        [attr.aria-label]="'layout.header.profile' | translate"
        [pTooltip]="profile()?.fullName || ('layout.header.profile' | translate)" tooltipPosition="bottom" [showDelay]="400">
        <span *ngIf="initials(); else profileIcon" class="layout-topbar-avatar" aria-hidden="true">{{ initials() }}</span>
        <ng-template #profileIcon><i class="pi pi-user"></i></ng-template>
        <span class="title-topbar-button">{{ 'layout.header.profile' | translate }}</span>
      </button>
    </div>
  </div>

  <p-overlayPanel #userProfilePanel>
    <ng-template pTemplate="content">
      <div class="flex flex-column justify-content-start w-15rem gap-1">
        <h5 class="w-full text-center text-color-secondary">{{ profile()?.fullName }}</h5>
        <p-divider></p-divider>
        <p-button icon="pi pi-lock mx-2 mb-2" severity="secondary" styleClass="w-full mb-2" (onClick)="showChangePasswordDialog()">
          {{ 'layout.header.updatePassword' | translate }}
        </p-button>
        <p-button icon="pi pi-sign-out mx-2" severity="secondary" styleClass="w-full" (click)="logout()">
          {{ 'layout.header.logout' | translate }}
        </p-button>
      </div>
    </ng-template>
  </p-overlayPanel>

  <p-dialog [header]="'layout.header.changePasswordDialog.title' | translate" [(visible)]="changePasswordDialogVisible" [modal]="true" [style]="{ width: '400px' }" [draggable]="false" [resizable]="false">
    <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePasswordSubmit()" class="p-fluid mt-3">
      <div class="field mb-4">
        <label for="currentPassword" class="block font-medium mb-2">{{ 'layout.header.changePasswordDialog.currentPassword' | translate }}</label>
        <p-password id="currentPassword" formControlName="currentPassword" [feedback]="false" [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full"></p-password>
        <small class="p-error block mt-1" *ngIf="changePasswordForm.get('currentPassword')?.hasError('required') && changePasswordForm.get('currentPassword')?.touched">
          {{ 'layout.header.changePasswordDialog.currentPasswordRequired' | translate }}
        </small>
        <small class="p-error block mt-1" *ngIf="changePasswordForm.get('currentPassword')?.hasError('incorrect')">
          {{ 'layout.header.changePasswordDialog.currentPasswordIncorrect' | translate }}
        </small>
      </div>
      <div class="field mb-4">
        <label for="newPassword" class="block font-medium mb-2">{{ 'layout.header.changePasswordDialog.newPassword' | translate }}</label>
        <p-password id="newPassword" formControlName="newPassword" [feedback]="true" [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full"></p-password>
        @if (changePasswordForm.controls['newPassword'].touched && changePasswordForm.controls['newPassword'].hasError('required')) {
          <small class="p-error block mt-2">{{ 'layout.header.changePasswordDialog.newPasswordRequired' | translate }}</small>
        } @else if (changePasswordForm.controls['newPassword'].touched && changePasswordForm.controls['newPassword'].hasError('minlength')) {
          <small class="p-error block mt-2">{{ 'layout.header.changePasswordDialog.passwordMinLength' | translate }}</small>
        } @else if (changePasswordForm.controls['newPassword'].touched && changePasswordForm.controls['newPassword'].hasError('weakPassword')) {
          <small class="p-error block mt-2">
            {{ 'layout.header.changePasswordDialog.passwordWeak' | translate }}
          </small>
        } @else if (
          changePasswordForm.controls['newPassword'].touched &&
          changePasswordForm.hasError('sameAsCurrentPassword')
        ) {
          <small class="p-error block mt-2">
            {{ 'layout.header.changePasswordDialog.passwordSameAsCurrent' | translate }}
          </small>
        }
      </div>
      <div class="field mb-4">
        <label for="confirmPassword" class="block font-medium mb-2">{{ 'layout.header.changePasswordDialog.confirmPassword' | translate }}</label>
        <p-password id="confirmPassword" formControlName="confirmPassword" [feedback]="false" [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full"></p-password>
        @if (changePasswordForm.controls['confirmPassword'].touched && changePasswordForm.controls['confirmPassword'].hasError('required')) {
          <small class="p-error block mt-2">{{ 'layout.header.changePasswordDialog.confirmPasswordRequired' | translate }}</small>
        }
        @if (changePasswordForm.touched && changePasswordForm.hasError('mismatch')) {
          <small class="p-error block mt-2">{{ 'layout.header.changePasswordDialog.passwordMismatch' | translate }}</small>
        }
      </div>
      <div class="flex justify-content-end gap-2 mt-4">
        <p-button [label]="'layout.header.changePasswordDialog.cancel' | translate" icon="pi pi-times" severity="secondary" (onClick)="changePasswordDialogVisible = false" type="button"></p-button>
        <p-button [label]="'layout.header.changePasswordDialog.save' | translate" icon="pi pi-check" type="submit" [loading]="isChangingPassword"></p-button>
      </div>
    </form>
  </p-dialog>
</div>
